// extracted by mini-css-extract-plugin
module.exports = {"div":"HelperModal_div__ysufS","title":"HelperModal_title__3cXfM","text":"HelperModal_text__MNhkE"};